<template>
  <div
    v-if="isOpen"
    class="overlay-container"
    @click.self="$emit('close')">
    <!-- Fixed circular nav buttons -->
    <button
      :disabled="!hasPrev"
      class="order-button prev"
      :aria-label="tStatic('previous')"
      @click="prevOrder">
      〱
    </button>

    <button
      :disabled="!hasNext"
      class="order-button next"
      :aria-label="tStatic('previous')"
      @click="nextOrder">
      <span class="rotated-text">〱</span>
    </button>

    <!-- Fixed top bar with close button -->
    <div class="top-bar">
      <button class="close-button my-pages-template__action base-action base-action--flat base-action--medium" @click="$emit('close')">
        <oie-base-icon icon="arrow-left" size="s"></oie-base-icon>
        <span>{{ tStatic('goBack') }}</span>
      </button>

      <div class="top-bar-title">
        <h1 class="my-pages-title__main">
          {{ t("orderNumberLabel") }} {{ currentOrder.orderNr }}
        </h1>
      </div>
    </div>

    <div class="overlay-content">
      <oie-order-history-details-container :order-number="selectedOrderId"></oie-order-history-details-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OrderNavigator',
  props: {
    orders: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedOrderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    currentOrder() {
      return this.orders[this.currentIndex] || {}
    },
    hasPrev() {
      return this.currentIndex > 0
    },
    hasNext() {
      return this.currentIndex < this.orders.length - 1
    }
  },
  watch: {
    selectedOrderId(newId) {
      const index = this.orders.findIndex(o => o.orderNr === newId)
      if (index !== -1) {
        this.currentIndex = index
      }
    },
    orders: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.currentIndex = 0
        }
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    ...mapActions(['someActionIfNeeded']),
    nextOrder() {
      if (this.hasNext) {
        this.currentIndex++
        this.selectedOrderId = this.currentOrder.orderNr
        this.fetchAdditionalData()
      }
    },
    prevOrder() {
      if (this.hasPrev) {
        this.currentIndex--
        this.selectedOrderId = this.currentOrder.orderNr
        this.fetchAdditionalData()
      }
    },
    handleKeydown(event) {
      if (!this.isOpen) return

      if (event.key === 'ArrowLeft') {
        this.prevOrder()
      } else if (event.key === 'ArrowRight') {
        this.nextOrder()
      }
    }
  }
}
</script>

<style scoped>
  .overlay-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(30, 41, 59, 0.6);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 1000;
    padding-top: 4rem;
  }

  .top-bar {
    position: fixed;
    top: 0;
    left: 5%;
    width: 90%;
    height: 3rem;
    background: white;
    z-index: 1050;
    display: flex;
    align-items: center;
    padding-left: 1rem;
    /*box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);*/
    margin-top: 2rem;
  }

  .top-bar-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
  }

  .close-button {
    border: none;
    color: rgb(0, 109, 182);
    cursor: pointer;
    margin-left: -10px;
  }

  .overlay-content {
    background: #ffffff;
    width: 90%;
    max-height: 95%;
    overflow-y: auto;
    padding: 1.5rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    position: relative;
    overflow-x: visible;
    padding-top: 5rem; /* Space for fixed top bar */
  }

  .order-button {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    width: 3rem;
    height: 3rem;
    padding: 0;
    background-color: #006db6;
    color: white;
    border: none;
    border-radius: 50%;
    font-weight: 700;
    font-size: 1.5rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.2s ease;
    user-select: none;
    z-index: 1100;
  }

    .order-button:hover:enabled {
      background-color: #44b1fa;
    }

    .order-button:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .order-button.prev {
      left: calc(5% - 1.5rem);
    }

    .order-button.next {
      right: calc(5% - 1.5rem);
    }

  .rotated-text {
    display: inline-block;
    transform: rotate(180deg);
  }
</style>
